import axios from 'axios';
import { makeRequester } from '@arc/shared/util-route-schema';

// This is explicitly for calls to our /api so we don't leak CSRF tokens should other calls be added.
const arcAdminApi = axios.create();
const unsafeMethods = new Set(['delete', 'patch', 'post', 'put']);
async function getCsrfToken() {
  const {
    data
  } = await arcAdminApi.get('/api/csrf-token');
  return data.csrfToken;
}
arcAdminApi.interceptors.request.use(async config => {
  if (!config.method || !unsafeMethods.has(config.method.toLowerCase())) {
    return config;
  }
  config.headers.set('x-csrf-token', await getCsrfToken());
  return config;
});
export const apiRequest = makeRequester(arcAdminApi);